import axios from "axios";
import { defineStore } from "pinia";
import type { Partner } from "~/types/Partner";
import persistedState from 'pinia-plugin-persistedstate'; // Assuming this is needed based on previous file content 'persistedState.sessionStorage'

export const usePartnerStore = defineStore('partner', {
    state: () => ({}),
    actions: {
        async fetchPartnerByCode(code: string, token: string | undefined): Promise<Partner | null> {
            try {
                const response = await axios.get(`${import.meta.env.VITE_API_BASE_URL}/api/v1/partners/${code}?token=${token}`);
                if (response.data.data) {
                    return response.data.data as Partner;
                } else {
                    return null;
                }
            } catch (err) {
                const error = err as { response: { status: number } };
                if (error.response && (error.response.status === 404 || error.response.status === 403)) {
                    return null;
                } else {
                    throw err;
                }
            }
        },
        async storePartnerInvitation(partner: Partner | FormData, inviteCode: string, token: string | undefined): Promise<Partner | null> {
            try {
                const response = await axios.post(`${import.meta.env.VITE_API_BASE_URL}/api/v1/partners/invite/${inviteCode}?token=${token}`, partner);
                if (response.data.data) {
                    return response.data.data as Partner;
                } else {
                    return null;
                }
            } catch (err) {
                const error = err as { response: { status: number, data: any } };
                if (error.response && error.response.data) {
                    throw error.response.data;
                }
                throw err;
            }
        }
    },
    persist: {
        storage: persistedState.sessionStorage,
        paths: [],
        key: 'partnerStore',
    }
});
